export default {
  'label/service_menu/confirmed': 'Marcar como Contratado',
  'label/service_menu/canceled': 'Marcar como Cancelado',
  'label/service_menu/forecasted': 'Marcar como Previsto',
  'label/service_menu/edit': 'Editar',
  'label/payment_menu/verified': 'Marcar como Verificado',
  'label/payment_menu/unverified': 'Marcar como No Verificado',
  'label/payment_menu/on_debt': 'Marcar como en Deuda',
  'label/payment_menu/new_receipt': 'Generar Recibo',
  'label/payment_menu/edit': 'Editar',
  'label/tab_items/profile': 'Registro',
  'label/tab_items/timeline': 'Expediente',
  'label/tab_items/financial': 'Financiero',
  'action/new_service': 'Nuevo Servicio',
  'action/new_payment': 'Nuevo Pago',
  'action/new_receipt': 'Nuevo Recibo',
  'action/delete_service': 'Eliminar servicio',
  'action/delete_payment': 'Eliminar pago',
  'action/delete_receipt': 'Eliminar recibo',
  'action/create_new_receipt': 'Crear Nuevo Servicio',
  'action/edit_services': 'Editar Servicios',
  'label/with_installments': 'Parcelar pago',
  'label/installments': 'Nº de parcelas',
  'label/services': 'Servicios',
  'label/payments': 'Pagos',
  'label/receipt': 'Recibo',
  'label/receipt_number': 'Recibo nº {0}',
  'label/receipts': 'Recibos',
  'label/balance': 'Saldo',
  'label/financial': 'Financiero',
  'label/services_empty/title': 'No hay servicios registrados.',
  'label/receipts_empty/title': 'No hay recibos registrados.',
  'label/payments_empty/title': 'No hay pagos registrados.',
  'label/new_service_to': 'Nuevo Servicio para',
  'label/edit_service': 'Editar Servicio',
  'label/error/name': 'Informe un nombre',
  'label/error/date': 'Seleccione una fecha',
  'label/error/value': 'Informe un valor válido',
  'label/edit_receipt': 'Editar Recibo',
  'label/edit_receipt_number': 'Editar Recibo nº {0}',
  'label/new_receipt_to': 'Nuevo Recibo para',
  'label/service_provided': 'Servicio Prestado',
  'label/additional_informations': 'Informaciones Adicionales',
  'label/seller_name': 'Nombre Completo del Profesional',
  'label/seller_cpf': 'Tax ID del Profesional',
  'action/patient_not_buyer': 'Pago no realizado por el paciente',
  'label/buyer': 'Responsable del pago',
  'label/buyer_name': 'Nombre del Responsable del Pago',
  'label/buyer_cpf': 'Tax ID del Responsable del Pago',
  'label/error/service': 'Informe un servicio',
  'label/error/price': 'Informe un precio',
  'label/error/cpf': 'Informe un Tax ID válido',
  'label/error/patient_name': 'Nombre del paciente requerido',
  'label/error/seller': 'Profesional requerido',
  'label/error/buyer': 'Informe el nombre del responsable',
  'label/service_taker': 'Tomador de los servicios',
  'label/responsible_info': 'Responsable del pago y tomador de los servicios',
  'label/service_provider': 'Prestador de los servicios',
  'label/receipt_title': 'Recibo de Honorarios nº',
  'label/payment_method': 'Medio de Pago',
  'label/check_number': 'Núm. del Cheque',
  'label/with_invoice': 'Con Factura',
  'label/invoice_number': 'Número de la Factura',
  'label/error/valid_value': 'Informe un valor válido.',
  'action/add_new_services': 'Agregar Nuevos Servicios',
  'label/debt_balance': 'Saldo Deudor',
  'action/search_service': 'Buscar servicio existente',
  // services sold by quantity
  'label/unit_price': 'Valor unitario',
  'label/total_price': 'Valor total',
  'label/discount': 'descuento',
  'label/surcharge': 'recargo',
  'label/discount_hint': 'Descuento de {{amount}} sobre {{quantity}} × {{unitPrice}}',
  'label/surcharge_hint': 'Recargo de {{amount}} sobre {{quantity}} × {{unitPrice}}',
  'label/per_unit': 'por {{unit}}',
  'label/table_price': 'tabla {{price}}',
  'label/selected_services': '{{count}} servicio seleccionado',
  'label/selected_services_plural': '{{count}} servicios seleccionados',
  'label/error/quantity': 'Informe una cantidad',
  'label/error/quantity_of': 'Informe la cantidad de {{name}}',
  'action/decrease_quantity': 'Disminuir cantidad',
  'action/increase_quantity': 'Aumentar cantidad',
  // the phone's Financeiro tab (PatientFinancialOverview)
  'overview/status/due': 'Pendiente',
  'overview/status/settled': 'Al día',
  'overview/status/credit': 'A favor',
  'overview/contracted': 'Servicios contratados',
  'overview/paid': 'Pagos recibidos',
  'overview/balance_error': 'No se pudo cargar el saldo.',
  'overview/retry': 'Reintentar',
  'overview/new_service': 'Servicio',
  'overview/new_payment': 'Pago',
  'overview/new_receipt': 'Recibo',
  'overview/payment': 'Pago',
  'overview/services_count': '{{count}} servicio',
  'overview/services_count_plural': '{{count}} servicios',
  'overview/payments_count': '{{count}} pago',
  'overview/payments_count_plural': '{{count}} pagos',
  'overview/receipts_count': '{{count}} recibo',
  'overview/receipts_count_plural': '{{count}} recibos',
  'overview/services_none': 'Ningún servicio',
  'overview/payments_none': 'Ningún pago',
  'overview/receipts_none': 'Ningún recibo',
  'overview/latest': 'último el {{date}}',
  'overview/recent': 'Movimientos recientes',
  'overview/see_all': 'Ver todo',
  'overview/list_error': 'No se pudieron cargar los movimientos.',
  'overview/services_error': 'No se pudieron cargar los servicios.',
  'overview/payments_error': 'No se pudieron cargar los pagos.',
  'overview/row_error': 'No se pudo cargar',
  'overview/empty/title': 'Aún no hay movimientos',
  'overview/empty/hint': 'Los servicios contratados y los pagos de este paciente aparecerán aquí.',
  'overview/empty/action': 'Nuevo servicio',
};
